export const historialPermitidoPorNombre = (value) => {
  const name = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
  return (
    [
      "admin",
      "planeacion",
      "admin iserra100",
      "admin iserra100 gerencia",
      "admin iserra100 supervisor",
    ].includes(name) || name.includes("administrador")
  );
};
